import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";
import { ListingModalSwapLimitReachedItem } from "./listingModalSwapLimitReachedItem/ListingModalSwapLimitReachedItem";
import { ToolTip } from "../../../../global/tooltip/ToolTip";
import { ListingModalSwapLimitWrapper } from "./ListingModalSwapLimitWrapper";
import { ListingModalSwapLimitContent } from "./ListingModalSwapLimitContent";
import { ListingModalSwapLimitHeader } from "./ListingModalSwapLimitHeader";
import { ListingModalSwapLimitTitle } from "./ListingModalSwapLimitTitle";
import { ListingModalSwapLimitParagraph } from "./ListingModalSwapLimitParagraph";
import { ListingModalSwapLimitParagraphLink } from "./ListingModalSwapLimitParagraphLink";
import { ListingModalSwapItemsWrapper } from "./ListingModalSwapItemsWrapper";
import { ListingModalSwapLimitCautionParagraph } from "./ListingModalSwapLimitCautionParagraph";
import { ActionsWrapper } from "../../../../global/modals/material/ActionsWrapper";
import { ListingModalSwapCancelBtn } from "./ListingModalSwapCancelBtn";
import { ListingModalSwapSubmitBtn } from "./ListingModalSwapSubmitBtn";
import { ListingModalSwapItemProvider } from "./listingModalSwapLimitReachedItem/ListingModalSwapItemProvider";
import { ListingModalSwapLimitReachedProvider } from "./ListingModalSwapLimitReachedProvider";

export const ListingModalSwapLimitReached = () => {
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan,
  );
  const currentSubscription = trainingPlanRedux?.userFullSubscriptionData;
  const currentSubscriptionProviderData =
    currentSubscription?.subscriptionPlanPaymentProviders;
  const currentBorrowedListings = trainingPlanRedux.borrowedListings;
  const currentBorrowedListingIsAlreadyOwned = !!currentBorrowedListings.find(
    (item) => item.listingId === trainingPlanRedux.listingData.id,
  );

  return (
    <ListingModalSwapLimitReachedProvider>
      <ListingModalSwapLimitWrapper>
        <ListingModalSwapLimitContent>
          <ListingModalSwapLimitHeader>
            <ListingModalSwapLimitTitle>
              Return a training plan
            </ListingModalSwapLimitTitle>

            <ToolTip
              title={`You have ${trainingPlanRedux.borrowedListings.length} active Training Plans`}
              description={`
              With a ${
                currentSubscription?.title.split("v2")[0]
              } membership you can unlock ${
                currentSubscriptionProviderData[0].totalPlans
              } training plans each month, but can have a maximum of ${
                currentSubscriptionProviderData[0].currentPlans
              } in your library at one time`}
            />
          </ListingModalSwapLimitHeader>

          <ListingModalSwapLimitParagraph>
            You have reached the limit of borrowed training plans that you can
            have unlocked at one time. To continue, choose a training plan to
            return, or{" "}
            <ListingModalSwapLimitParagraphLink>
              upgrade
            </ListingModalSwapLimitParagraphLink>{" "}
            to increase your allowance.
          </ListingModalSwapLimitParagraph>
        </ListingModalSwapLimitContent>

        <ListingModalSwapItemsWrapper>
          {currentBorrowedListings?.map((item) => {
            return (
              <ListingModalSwapItemProvider
                key={item.listingId}
                currentListing={item.listing}
              >
                <ListingModalSwapLimitReachedItem />
              </ListingModalSwapItemProvider>
            );
          })}
        </ListingModalSwapItemsWrapper>

        {currentBorrowedListingIsAlreadyOwned ? (
          <ListingModalSwapLimitCautionParagraph>
            Caution! You are trying to swap a training you already have!
          </ListingModalSwapLimitCautionParagraph>
        ) : null}

        <ActionsWrapper>
          <ListingModalSwapCancelBtn />
          <ListingModalSwapSubmitBtn />
        </ActionsWrapper>
      </ListingModalSwapLimitWrapper>
    </ListingModalSwapLimitReachedProvider>
  );
};
